import Crosshairs from './Crosshairs';
import { PlaneView } from '~/engine/view/views/PlaneView';

export interface CrosshairsComponentProps {
    view: PlaneView | null;
}

const CrosshairsComponent = ({ view }: CrosshairsComponentProps) => {
    const vertical = view?.planeIntersectionPointToScrollLevel().vertical;
    const horizontal = view?.planeIntersectionPointToScrollLevel().horizontal;

    const handleCrosshairChange = (
        type: 'horizontal' | 'vertical',
        delta: number
    ) => {
        if (!view) return;
        view.scrollLevelToPlaneIntersectionPoint(type, delta);
    };

    return (
        vertical &&
        horizontal && (
            <Crosshairs
                vertical={vertical}
                horizontal={horizontal}
                handleCrosshairChange={handleCrosshairChange}
            />
        )
    );
};

export default CrosshairsComponent;
